import { InjectionToken } from '@angular/core';
import { HasuraBaseQuery, HasuraQuery } from '@anduin/shared';

export const EMAIL_DELIVERY_HUB_HASURA_BASE_QUERY_TOKEN = new InjectionToken<HasuraBaseQuery>('EMAIL_DELIVERY_HUB_HASURA_BASE_QUERY_TOKEN');

export const EMAIL_DELIVERY_HUB_HASURA_BASE_QUERY = new HasuraBaseQuery(
  'getOutBoundEmails',
  'vw_outbound_emails',
  [
    new HasuraQuery('outbound_email_v4_id', null, null, 'id'),
    new HasuraQuery('bcc'),
    new HasuraQuery('bounced'),
    new HasuraQuery('bounced_at', null, null, 'bouncedAt'),
    new HasuraQuery('cc'),
    new HasuraQuery('clicked'),
    new HasuraQuery('delivered'),
    new HasuraQuery('delivered_at', null, null, 'deliveredAt'),
    new HasuraQuery('clicked_at', null, null, 'clickedAt'),
    new HasuraQuery('opened_at', null, null, 'openedAt'),
    new HasuraQuery('from_address', null, null, 'fromAddress'),
    new HasuraQuery('opened'),
    new HasuraQuery('recipients'),
    new HasuraQuery('sent_at', null, null, 'sentAt'),
    new HasuraQuery('subject'),
    new HasuraQuery('failure_reason', null, null, 'failureReason'),
    new HasuraQuery('email_type', null, null, 'emailType'),
    new HasuraQuery('status'),
    new HasuraQuery('recipient_details', null, null, 'recipientDetails'),
    new HasuraQuery('invoice_ids', null, null, 'invoiceIds'),
    new HasuraQuery('action_def_id', null, null, 'actionDefId'),
    new HasuraQuery('action_def_instance_id', null, null, 'actionDefInstanceId'),
    new HasuraQuery('outbound_email_id', null, null, 'outboundEmailId'),
    new HasuraQuery('use_case_instance_id', null, null, 'useCaseInstanceId'),

    // New fields
    new HasuraQuery('client_partner_names', null, null, 'clientPartnerNames'),
    new HasuraQuery('client_manager_names', null, null, 'clientManagerNames'),
    new HasuraQuery('client_names', null, null, 'clientNames'),
    new HasuraQuery('client_ids', null, null, 'clientIds'),
    new HasuraQuery('client_group_names', null, null, 'clientGroupNames'),
    new HasuraQuery('attachment_names', null, null, 'attachmentNames'),
    new HasuraQuery('office_names', null, null, 'officeNames'),
  ],
  // new WhereCondition('email_type', WhereOperator.IN, INCLUDED_EMAIL_TYPES),
);
